module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1f0P6g/tc-custom/9781460377659.jpg?1716663322030",
      "alt": "This image is the cover for the book Rescuing Dr. Mcallister"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rescuing Dr. Mcallister\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A feisty nurse is puzzled by an icy new doctor in this workplace romance by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("A&E nurse Ellie Harrison is immediately intrigued by the ruggedly handsome new doctor at Ambleside. Dr. Ben MacAllister is playing it cool but, the pace and excitement of the A&E department thrusts them together and reveals that Ben’s growing attraction is as strong as hers."), _c('br'), _c('br'), _vm._v("Then Ellie realizes Ben has a secret that is holding him back, and she decides there is only one way to help him move on—by offering herself as a distraction!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah Morgan is a USA Today and Sunday Times bestselling author of contemporary romance and women's fiction. She has sold more than 21 million copies of her books and her trademark humour and warmth have gained her fans across the globe. Sarah lives with her family near London, England, where the rain frequently keeps her trapped in her office. Visit her at www.sarahmorgan.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0